import { render, staticRenderFns } from "./GenreTile.vue?vue&type=template&id=17c1e968&scoped=true"
import script from "./GenreTile.vue?vue&type=script&lang=ts"
export * from "./GenreTile.vue?vue&type=script&lang=ts"
import style0 from "./GenreTile.vue?vue&type=style&index=0&id=17c1e968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1e968",
  null
  
)

export default component.exports